import React from 'react';
import './style.css';
import { useModal } from '../../../../context/ModalContext';
import FormWrapper from '../FormWrapper';
const PmsForm = () => {
    const { modals, closeModal } = useModal();

    return (
        <FormWrapper
            open={modals.pms}
            handleClose={() => closeModal('pms')}
            formId="a5504f27-14c8-4f8e-9ce7-742e3107cfab"
            targetId="pmsContactForm"
            heading="Let Us Know"
            subTitle="We will start working on your favorite PMS right away! Submit the form and feel free to reach out for any questions or suggestions."
            confirmMessageHeading={
                <>
                    🎉 Thanks for the <br /> awesome recommendation!
                </>
            }
            confirmationMessage="Our product team is already rolling up their sleeves to make this integration happen. Keep an eye on your inbox for some early access goodness and exclusive perks headed your way—exciting stuff coming soon! 🚀"
        />
    );
};

export default PmsForm;
